module.exports = __webpack_public_path__ + "img/Mockup 1.2e301bc0.png";